import ReactChoiceDisplay from '../../../../blocks/react-choice-display';
const ReactChoiceDisplayGrapeJs = (props) => {
    return <ReactChoiceDisplay {...props} />;
};


export default (editor) => {
    const domc = editor.Components;
    domc.addType('reactChoiceDisplay', {
        extend: 'react-component',
        model: {
            defaults: {
                component: ReactChoiceDisplayGrapeJs,
                stylable: false,
                resizable: false,
                editable: false,
                draggable: false,
                droppable: false,
                hoverable: false,
                selectable:false,
                attributes: {
                    editable: false,
                },
                traits: [],
            },
        },
        isComponent: (el) => el.tagName === 'REACTCHOICEDISPLAY',
    });
};
